import apiService from '../service/apiService';
import * as Utility from '../HelperMethods/UtilityFunctions';
import logUtils from '../HelperMethods/LogUtils';

export const types = {
  LOADING_STOPS_FOR_AREA: 'LOADING_STOPS_FOR_AREA',
  LOAD_STOPS_FOR_AREA_SUCEESS: 'LOAD_STOPS_FOR_AREA_SUCEESS',
  LOAD_STOPS_FOR_AREA_FAILURE: 'LOAD_STOPS_FOR_AREA_FAILURE',
  LOADING_STOPS_FOR_FIELD: 'LOADING_STOPS_FOR_FIELD',
  LOAD_STOPS_FOR_FIELD_SUCCESS: 'LOAD_STOPS_FOR_FIELD_SUCCESS',
  LOAD_STOPS_FOR_FIELD_FAILURE: 'LOAD_STOPS_FOR_FIELD_FAILURE',
};

export function getStopsByField(field) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_STOPS_FOR_FIELD });
    try {
      const output = await apiService.getAssetsByFieldAndTypesRPC(field.id, ['stop']);
      const stopsOutput = Utility.inflateResponse(output);
      dispatch({
        type: types.LOAD_STOPS_FOR_FIELD_SUCCESS,
        items: stopsOutput,
      });
    } catch (e) {
      logUtils.logError(e);
      dispatch({ type: types.LOAD_STOPS_FOR_FIELD_FAILURE });
    }
  };
}
